import { jsx } from "react/jsx-runtime";
import { COUNTRY_CODES } from "@wix/form-multiline-address";
import { useAddressLabel } from "../../../hooks/use-address-label.js";
import { useCountryCode } from "../../multiline-address/multiline-address/country-code-context.js";
import JapanPostalCodeWUT from "./japan-postal-code-wut.js";
import { TextInputFieldWUT } from "../../../ui/text-input-field/text-input-field-wut.js";
import { FIELD_TYPES } from "../../../constants/field-types.js";
const MlaPostalCodeWUT = (props) => {
  const fieldType = FIELD_TYPES.MLA_POSTAL_CODE;
  const label = useAddressLabel("zipCode");
  const countryCode = useCountryCode();
  const isJapan = Boolean(
    countryCode && COUNTRY_CODES[countryCode] === COUNTRY_CODES.JP
  );
  return isJapan ? /* @__PURE__ */ jsx(JapanPostalCodeWUT, { ...props, fieldType, label }) : /* @__PURE__ */ jsx(TextInputFieldWUT, { ...props, fieldType, label });
};
export {
  MlaPostalCodeWUT
};
//# sourceMappingURL=mla-postal-code-wut.js.map
